import { useMutation } from '@tanstack/react-query';

import { fotosTemporalesApi } from '../api/fotosTemporalesApi';

export function useUploadFotoTemporal() {
  return useMutation({
    mutationFn: (contentType: string) => fotosTemporalesApi.requestUpload(contentType),
  });
}
